import styled from 'styled-components'
import { mix } from 'polished'

// Utils
import { breakpoint } from 'utils/breakpoint'

// Components
import Pill, { PillProps } from 'components/Pill'
import { FlatButton } from 'components/Button'
import RowGroup from '../RowGroup'

export const ButtonCell = styled(RowGroup.CaptionCell)`
  text-align: right;

  ${breakpoint('base', 'sm')`
    margin: 10px 0 0 0;
  `}
`

export const Description = styled.p`
  margin: 0;
`

export const ErrorPill = styled(Pill).attrs<PillProps>({
  variant: { kind: 'error' },
})`
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
`

export const StyledButton = styled(FlatButton)`
  display: inline;
  margin: 0;
  padding: 0;
  background: none;
  border: 0;
  color: ${({ theme }) => theme.colors.primaryTint[100]};
  cursor: pointer;
`

export const StyledFlatButton = styled(FlatButton)`
  padding: 0;
  transition: color ${({ theme }) => theme.transitions.duration[1]};
  color: ${({ theme }) => theme.colors.primary};
  font-weight: ${({ theme }) => theme.fontWeights.medium};

  &:hover {
    color: ${({ theme }) => mix(0.2, theme.colors.white, theme.colors.primary)};
  }

  &:active {
    color: ${({ theme }) => mix(0.2, theme.colors.black, theme.colors.primary)};
  }
`
